import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import FileUpload from '~/components/FileUpload'
import {
  StyledAvatarContainer,
  StyledAvatarWrapper,
  StyledAvatarImage,
  StyledDeleteButton
} from '../style'

const defaultImage = '/assets/default.png'

const AvatarUpload: React.FC = () => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()
  const photoFieldUrl = useWatch({ control, name: 'logo' })

  function handleDelete(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    setValue('logo', null)
  }

  return (
    <StyledAvatarContainer>
      {photoFieldUrl ? (
        <StyledAvatarWrapper>
          <StyledAvatarImage>
            <img
              src={photoFieldUrl || defaultImage}
              alt='Farmer avatar'
              className='avatar-image'
            />
          </StyledAvatarImage>
          <StyledDeleteButton
            className='delete-button'
            onClick={handleDelete}
            title={t('Remove photo')}
          >
            <Icon name='trash' />
          </StyledDeleteButton>
        </StyledAvatarWrapper>
      ) : (
        <FileUpload
          encodeFiles
          onChange={(value) => setValue('logo', value)}
          accept={{
            'image/bmp': ['.bmp'],
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/png': ['.png']
          }}
          sizeLimitInMB={5}
          type={'image-upload'}
        />
      )}
    </StyledAvatarContainer>
  )
}

export default AvatarUpload
